import { ButtonHTMLAttributes } from 'react';
import infoIcon from 'public/static/images/info-icon.svg';

export default function QuickViewIcon({
  onClick,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element {
  return (
    <>
      <div className="quick-view-icon-button-container">
        <button className="quick-view-icon-button" onClick={onClick} {...props}>
          <img
            data-testid="quick-view-heart"
            className="quick-view-heart"
            src={infoIcon}
            alt="quick-view"
          />
        </button>
      </div>
      <style jsx>{`
        .quick-view-icon-button-container {
          position: absolute;
          top: 68px;
          right: 12px;
          z-index: 9;
        }
        .quick-view-icon-button {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          height: 40px;
          width: 40px;
          border: none;
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.6);
        }
        @media (min-width: 950px) {
          .quick-view-icon-button-container {
            visibility: hidden;
            display: none;
          }
        }
      `}</style>
    </>
  );
}
